import { transition } from '../../utils/styleUtils';
import { createStyles } from '../../utils/styleUtils/createStyles';
export const useStyles = createStyles(()=>{
    return {
        root: {
            label: 'CategoryIcon-root',
            display: 'inline-block',
            flexShrink: 0,
            stroke: 'var(--icon-color)',
            color: 'var(--icon-color)',
            transition: transition({
                attributes: [
                    'transform',
                    'color'
                ],
                easing: 'wobbly',
                duration: 200
            }),
            [`a:hover &, a:focus &, 
        button:hover &, button:focus &`]: {
                transform: 'scale(1.1)'
            }
        }
    };
});
